import Toast from '../../scripts/toast.js'
import { request } from '../../scripts/utils.js'

export default {
  install(app) {
    app.config.globalProperties.Toast = Toast
    app.config.globalProperties.$request = request
  }
}
